export enum ProjectTypes {
  BrandActivation = 'Brand Activation',
  General = 'General',
}

export enum ServerProjectTypes {
  BrandActivation = 'brand_activation',
  General = 'general_project',
}
